export default function debounce(func, delay) {
  let debounceTimer;
  return function debouncedFunction(...args) {
    const context = this;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
}
